// Helpers for converting between a Date (e.g. from the Material datepicker) and a
// yyyy-MM-dd "date only" string. Local date parts are used deliberately to avoid the
// timezone shift that toISOString() introduces.

export function toDateOnly(date: Date | null): string | null {
  if (!date) return null;
  const y = date.getFullYear();
  const m = String(date.getMonth() + 1).padStart(2, '0');
  const d = String(date.getDate()).padStart(2, '0');
  return `${y}-${m}-${d}`;
}

export function fromDateOnly(value: string | null): Date | null {
  if (!value) return null;
  const [y, m, d] = value.split('-').map(Number);
  if (!y || !m || !d) return null;
  return new Date(y, m - 1, d);
}
